export default "__VITE_ASSET__fd15ce0e__"